import React from 'react';
import { Link } from 'react-router-dom';
import '../css/main/404.sass'
import config from '../config'

const NoPage = () => {
    return (
      <div className="page-404">
        <div className="page-404-text">
          <h1>404</h1>
          <h3>Page not found</h3>
          <h5>Looks like this page doesn't exist. Here are some links to get you back on track.</h5>
        </div>
        <div className="page-404-links">
          <a href={config.HOME_ROOT}>Home Page</a>
          <a href={config.HOME_ROOT + "/blog"}>Blog</a>
          <Link to="/">Login</Link>
          <Link to="/dashboard/overview">Dashboard</Link>
        </div>
      </div>
    )
}

export default NoPage;